import { EventRegistry } from '../../../../../domain/event/event.registry';
import { ReferenceTableEvent } from './reference-table.event';
export class ReferenceTableDeletedEvent extends ReferenceTableEvent {
    constructor(payload, metadata, fromPersistence) {
        super({
            subject: `reference-table/${payload.id}`,
            type: ReferenceTableDeletedEvent.type,
            payload,
            metadata,
            fromPersistence,
        });
    }
}
ReferenceTableDeletedEvent.subject = 'reference-table/aggregate/reference-table/ReferenceTableDeletedEvent';
ReferenceTableDeletedEvent.type = 'com.treeplotter.api.reference-table.deleted.v1';
EventRegistry.register(ReferenceTableDeletedEvent.type, ReferenceTableDeletedEvent);
//# sourceMappingURL=reference-table-deleted.event.js.map